<div class="admin-header">
  <ng-content></ng-content>
</div>
<kbxl-color-bar></kbxl-color-bar>
